// @flow

import React from 'react';
import { Typography } from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { AsyncBox } from '@fortress-technology-solutions/fortress-component-library/Molecules';
import { Form } from '@fortress-technology-solutions/fortress-component-library/Organisms';
import useIntl from '../../../hooks/useIntl';
import type { Step1Props } from './types';
import messages from './messages';
import { useStep1 } from './Step1.hooks';
import Step1Table from './Step1Table';

const Step1 = (step1Props: Step1Props) => {
  const intl = useIntl();
  const { reactHookFormProps, disabled } = step1Props;
  const { floorPlans, isLoading, isError, step1HeaderFields } =
    useStep1(step1Props);

  return (
    <Form
      ReactHookFormProps={reactHookFormProps}
      fields={step1HeaderFields}
      spacing={2}
      containerSX={{
        mb: 0,
      }}
      contentSX={{
        alignItems: { xs: 'stretch', md: 'flex-end' },
      }}
    >
      <AsyncBox loading={isLoading} sx={{ minHeight: 120 }}>
        {isError ? (
          <Typography variant="bodyMedium" color="error">
            {intl.formatMessage(messages.errorLoadingFloorPlans)}
          </Typography>
        ) : null}
        {!isLoading && !isError && floorPlans.length === 0 ? (
          <Typography variant="bodyMedium" color="text.secondary">
            {intl.formatMessage(messages.noHudFloorPlans)}
          </Typography>
        ) : null}
        {!isLoading && !isError && floorPlans.length > 0 ? (
          <Step1Table
            reactHookFormProps={reactHookFormProps}
            disabled={disabled}
            floorPlans={floorPlans}
          />
        ) : null}
      </AsyncBox>
    </Form>
  );
};

export default Step1;
